import { View } from "ui/atoms/view";
import { MedicationItemSummary } from "../atoms/MedicationItemSummary";
import { MedicationModel } from "app/services/api/types/medications/models/MedicationModel";
import { Text } from "react-native";
import { MedicationFormIcon } from "../atoms/MedicationFormIcon";
import { MedicationActionButtons } from "../organisms/MedicationActionButtons";
import ViewMore from "ui/molecules/common/ViewMore";
import { MedicationStatusIndicator } from "../atoms/MedicationStatusIndicator";
import StatusIndicator from "ui/atoms/avatar/statusIndicator/StatusIndicator";
import { MedicationAdministrationStatusEnum } from "../../../services/api/types/medications/enums/MedicationAdministrationStatusEnum";

interface MedicationItemContentProps {
  medication: MedicationModel;
  isViewing?: boolean;
  isDiscontinued?: boolean;
  startEditMedication?: (medication: MedicationModel) => void;
  startDiscontinueMedication?: (medication: MedicationModel) => void;
  viewMoreLink?: string;
  startAddNoteOrVoid?: (medication: MedicationModel) => void;
  medicationLogStatus?: MedicationAdministrationStatusEnum;
}

export function MedicationItemContent({
  medication,
  isViewing,
  startEditMedication,
  startDiscontinueMedication,
  viewMoreLink,
  isDiscontinued,
  startAddNoteOrVoid,
  medicationLogStatus,
}: MedicationItemContentProps) {
  return (
    <View className="w-full">
      <View className="flex-row justify-between py-5 px-7 gap-y-4 gap-x-2 sm:gap-y-1">
        <View className="flex-1 gap-4">
          <View className="flex flex-row items-center gap-4 ">
            <MedicationFormIcon type={medication.form} />
            <View className="gap-y-2 flex-1">
              <Text className="font-semibold text-typography-900 line-clamp-3">
                {medication.name}
              </Text>
              {medication.notes ? (
                <Text className="text-typography-900 flex-wrap max-w-sm">
                  Notes: {medication.notes}
                </Text>
              ) : null}
            </View>
          </View>
          <MedicationItemSummary
            medication={medication}
            className="xl:col-span-6 col-span-12 w-full"
          />
        </View>
        <View className={`flex-col justify-between items-end`}>
          <View className="flex-row gap-3">
            {medicationLogStatus ===
            MedicationAdministrationStatusEnum.VOIDED ? (
              <StatusIndicator
                status="danger"
                statusTitle={medicationLogStatus}
              />
            ) : (
              <MedicationStatusIndicator medication={medication} />
            )}
          </View>
          {!isDiscontinued ? (
            isViewing ? (
              <MedicationActionButtons
                medication={medication}
                onEdit={startEditMedication}
                onDiscontinue={startDiscontinueMedication}
                onAddNoteOrVoid={startAddNoteOrVoid}
              />
            ) : (
              <ViewMore link={viewMoreLink} />
            )
          ) : null}
        </View>
      </View>
    </View>
  );
}
